import actions from './actions';
import { createReducer } from '../../../helpers/reducer';

// ------------------------------
// Initial State
// ------------------------------
const initState = {
  historicalOverview: '',
  card: null,
  piesData: null,
  dateScore: undefined,
  risk: null,
  risks: null,
  diagrams: null,
  diagrams_1: null,
  diagrams_6: null,
  historicalChartView: 3,
  loading: false,
  publicationDate: undefined,
  reportName: undefined,
  reportDate: undefined,
};

// ------------------------------
// Action Handlers
// ------------------------------
function onLoadRiskSuccess(state, { payload }) {
  const {
    card,
    piesData,
    risk,
    dateScore,
    diagrams,
    diagrams_1,
    diagrams_6,
    historicalChartView,
    publicationDate,
    reportName,
    reportDate,
  } = payload;

  return {
    ...state,
    card,
    piesData,
    risk,
    dateScore,
    diagrams,
    diagrams_1,
    diagrams_6,
    historicalChartView,
    publicationDate,
    reportName,
    reportDate,
  };
}

function onLoadError(state) {
  return {
    ...state,
    isLoading: false,
  };
}

function onSwitchChartView(state, { payload }) {
  const { historicalChartView } = payload;

  return {
    ...state,
    historicalChartView,
  };
}

function onClear(state) {
  return {
    ...state,
    keywords: [],
  };
}

// ------------------------------
// Exported reducer function.
// ------------------------------
export default createReducer(initState, {
  [actions.SWITCH_CHART_VIEW]: onSwitchChartView,
  [actions.LOAD_RISK_SUCCESS]: onLoadRiskSuccess,
  [actions.LOAD_ERROR]: onLoadError,
  [actions.CLEAR]: onClear,
});
